import * as React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import PermitContent from "../../Pages/PermitContent";
import Text from "../../Text/Text";
import { Divider, List, ListItem, ListItemText } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {
  hideAllBuyPermitList,
  showPrivacyPolicyModal,
} from "../../../store/login/action";
import PrivacyPolicy from "../PrivacyPolicy";

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: "500px",
  },
  textPadding: {
    padding: "20px 0px 20px 30px",
  },
  heading: {
    fontWeight: 700,
  },
  headinText: {
    color: theme.palette.primary.main,
    fontWeight: "600",
  },
  active: {
    background: "gray",
  },
  dflex: {
    display: "flex",
  },
  firstStepFirstChildMaindiv: {
    padding: "4px",
    width: "132px",
    color: "white",
    marginRight: "15px",
    height: "auto",
    border: "1px solid gray",
    textAlign: "center",
  },
  firstStepFirstChild: {
    background: theme.palette.primary.main,
    padding: "4px",
    width: "125px",
    color: "white",
    borderRadius: "2px",
    marginRight: "15px",
  },
  firstStepFirstChildmain: {
    background: theme.palette.primary.main,
    padding: "4px",
    width: "125px",
    color: "white",
    borderRadius: "2px",
    marginRight: "15px",
  },
  p5: {
    padding: "5px",
    alignItems: "center",
    textAlign: "center",
  },
  p5main: {
    padding: "5px",
    alignItems: "center",
    textAlign: "center",
    width: "100%",
    margin: "5px",
    height: "50px",
  },
  thirdStepFirstDivChild: {
    background: theme.palette.primary.main,
    padding: "4px",
    color: "white",
  },
  thirdStepFirstDivChildmain: {
    background: theme.palette.primary.main,
    padding: "10px",
    color: "white",
    fontSize: "20px",
  },
  mt18: {
    marginTop: "-18px",
  },
}));

const AllBuyPermitList = ({
  handleSelectPermit,
  permitList,
  profileUpdateData,
  selectedPermit,
}) => {
  const loginStore = useSelector((state) => state["loginState"]);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(hideAllBuyPermitList());
  };
  const handlePrivacy = () => {
    dispatch(showPrivacyPolicyModal());
  };
  const classes = useStyles();
  return (
    <>
      <Dialog
        open={loginStore && loginStore.allBuyperitListModal}
        maxWidth="md"
        fullWidth
      >
        <Grid container xs={12} md={12} spacing={2}>
          <div
            className={`${classes.firstStepFirstChildmain} ${classes.p5main}`}
          >
            <div className={classes.thirdStepFirstDivChildmain}>
              Select Your Permit
            </div>
          </div>
          <List className={classes.vehicleDiv}>
            {permitList &&
              permitList?.map((item, index) => {
                return (
                  <>
                    <ListItem
                      key={index}
                      className={`${classes.activeVehicleRow} ${classes.vehicleRow}`}
                      spacing
                      onClick={() => {
                        handleSelectPermit(item?.id);
                      }}
                      className={
                        selectedPermit && selectedPermit?.id === item?.id
                          ? classes.active
                          : ""
                      }
                    >
                      <ListItemText>
                        <>
                          <div className="d-flex contentwrapper">
                            <PermitContent permit={item} />

                            <div className="text-left">
                              <p className={classes.headinText}>
                                {`${item?.name}`} &nbsp;{" "}
                                <b>{item?.permitType}</b>
                              </p>

                              <p>
                                {`Good from ${item?.validStartDate} to ${item?.validEndDate}`}
                              </p>
                              <p>${item?.price?.toFixed(2)}</p>
                              <p>{item?.allowedNoVehicles} item limit</p>
                            </div>
                          </div>{" "}
                        </>
                        {/* <div className={classes.dflex}>
                        <div className={classes.firstStepFirstChildMaindiv}>
                          <div
                            className={`${classes.firstStepFirstChild} ${classes.p5}`}
                          >
                            <div className={classes.thirdStepFirstDivChild}>
                              {item.name}
                            </div>
                            {item.id}
                          </div>
                          <div>
                            <p style={{ color: "black" }}>STXXX</p>
                          </div>
                        </div>
                        <div className={classes.mt18}>
                          <p>
                            {profileUpdateData?.vehicles.map((vitem) => (
                              <>
                                {vitem?.year} {vitem?.color} {vitem?.model}{" "}
                                {vitem?.make?.name}
                              </>
                            ))}
                          </p>

                          <p>
                            {`Good from ${item?.validStartDate} to ${item?.validEndDate}`}
                          </p>
                          <p>${item?.price}</p>
                          <p>2 item limit</p>
                        </div>
                      </div> */}
                      </ListItemText>
                    </ListItem>
                    <Divider />
                  </>
                );
              })}
          </List>
        </Grid>
        <DialogActions>
          <Button onClick={handleClose} color="primary" variant="contained">
            Ok
          </Button>
        </DialogActions>
        <PrivacyPolicy />
      </Dialog>
    </>
  );
};
export default AllBuyPermitList;
